module.exports = __webpack_public_path__ + "static/img/product16-1.3f79e621.png";